import { Component } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Boulder } from '../../model/boulder';
import { BoulderService } from '../../services/boulder.service';
import { BBStorage } from 'src/utils/bb-storage';

@Component({
  selector: 'app-ranking',
  templateUrl: './ranking.page.html',
  styleUrls: ['./ranking.page.scss'],
})
export class RankingPage {

  boulders: Boulder[];

  constructor(private boulderService: BoulderService,
    public bbStorage: BBStorage
  ) {
  }

  ionViewWillEnter() {
    this.refresh();
  }

  async onRefresh(event) {
    try {
      this.reloadBoulders();
    } finally {
      if (event) {
        event.target.complete();
      }
    }
  }

  private refresh() {
    this.reloadBoulders();
  }

  public async reloadBoulders() {
    this.boulders = null;
    this.boulders = await firstValueFrom(this.boulderService.getBoulders$());
  }
}
